import { Collapse, IconButton, Paper, Stack, Typography } from '@mui/material'
import { East, KeyboardArrowDownRounded, KeyboardArrowUpRounded } from '@mui/icons-material'
import NewTimepointBox from './NewTimepointBox'
import { useParams } from 'react-router-dom'
import { useState } from 'react'

export default function ExpandableUpdateSubmissionStatusTimepoint({
  selectedTimepointSubmissionId,
  selectedSubjectId,
  isExpandable = true,
}: {
  selectedTimepointSubmissionId: string | null
  selectedSubjectId: string | null
  isExpandable?: boolean
}) {
  const [isOpen, setIsOpen] = useState(true)
  const toggleOpen = () => setIsOpen((prev) => !prev)
  const { timepointSubmissionId, subjectId } = useParams()
  return (
    <Paper
      sx={{
        borderRadius: 3,
        boxShadow: 1,
      }}
    >
      <Stack padding={4} spacing={4}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography color="text.primary" variant="h6">
            New timepoint
          </Typography>
          {isExpandable && (
            <IconButton onClick={toggleOpen}>
              {isOpen ? <KeyboardArrowUpRounded /> : <KeyboardArrowDownRounded />}
            </IconButton>
          )}
        </Stack>
        <Collapse in={isExpandable ? isOpen : true} timeout="auto" unmountOnExit>
          <Stack direction="row" alignItems="center">
            <NewTimepointBox timepointSubmissionId={timepointSubmissionId || null} subjectId={subjectId || null} />
            <Stack padding={1}>
              <East />
            </Stack>
            <NewTimepointBox
              timepointSubmissionId={selectedTimepointSubmissionId}
              subjectId={selectedSubjectId || null}
            />
          </Stack>
        </Collapse>
      </Stack>
    </Paper>
  )
}
